<template>
    <div ref="counter">0</div>
</template>

<script>
import { CountUp } from 'countup.js';

    export default {
        props: {
            value: {
                required: true,
            },
        },

        mounted() {
            new CountUp(this.$refs.counter, parseInt(this.value), {
                separator: '.',
                decimal: ',',
            }).start();
        },
    };
</script>
